/* unplugin-vue-components disabled */import script from "./benefits-features.vue?vue&type=script&lang=js"
export * from "./benefits-features.vue?vue&type=script&lang=js"

import "./benefits-features.vue?vue&type=style&index=0&id=3cc22c3e&lang=scss"

const __exports__ = script;

export default __exports__